import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rtionline',
  templateUrl: './rtionline.component.html',
  styleUrls: ['./rtionline.component.css']
})
export class RtiOnlineComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}





// WEBPACK FOOTER //
// ./src/app/rtionline/rtionline.component.ts